
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import BorderBox from "@src/components/BorderBox";
import GoogleMap from "@src/components/GoogleMap";
import InstaImage from "@src/components/InstaImage";
import ListBox from "@src/components/ListBox";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuShiniseHarajukuShiniseTopImage } from "@src/constants/images";
export const meta = {
  path: "/media/harajuku/shinise",
  title: "【原宿】ハズさない老舗の名店ランチ３選",
  description: "原宿で長年愛され続けている老舗名店の味をご紹介させていただきます。蕎麦、ピッツェリア、焼き鳥の３つのジャンルに絞ってランチメニューをご紹介します。おすすめのメニュー、支払い方法、アクセスも掲載しているので、興味を持ったお店の情報は是非チェックしてみてください！",
  topImg: harajukuShiniseHarajukuShiniseTopImage,
  author: murakamiMasanori,
  tags: ["老舗", "原宿", "人気店", "まとめ記事"]
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Text = makeShortcode("Text");
const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿で長年愛され続けている老舗名店の味をご紹介させていただきます。`}</p>
    <p>{`まるで鎌倉にいるような蕎麦、ローマの雰囲気さながらの 30 年続く老舗ピッツェリア、40 年以上続く老舗の焼き鳥の３つの店舗についてご紹介させていただきます。`}</p>
    <p>{`おすすめのメニューは写真付きで、支払い方法、アクセスも掲載しているので、興味を持ったお店の情報は是非チェックしてみてください！`}</p>
    <h2>{`鎌倉　松原庵　槻`}</h2>
    <InstaImage postId="B5xewp9gj1L" mdxType="InstaImage" />
    <p>{`原宿駅から徒歩２，３分の立地にあるとは思えないほど、落ち着いた大人な雰囲気のある老舗のお蕎麦屋さん。
鎌倉に本店を構える『松原庵』 ですが、おいしい和食とおそばが好評で、食べログの評価も 3.66(2020 年 5 月時点)と老舗の名店として人気を保ち続けています。`}</p>
    <h3>{`まるで鎌倉に来たような店内`}</h3>
    <InstaImage postId="BxZ5EfiAMlW" mdxType="InstaImage" />
    <p>{`原宿駅表参道口をでて、表参道沿いに少し下ると原宿クエストというビルが左手に。
お一人様だとカウンターで一人でランチされている OL やサラリーマン、都会の喧騒を離れたい大人の原宿デートとしてオススメです！`}</p>
    <h3>{`ランチ`}</h3>
    <InstaImage postId="Bl1mLGcjSZX" mdxType="InstaImage" />
    <p>{`手軽なものから、会食でも使えそうなもの、お昼から飲みたくなるメニューま様々な形で老舗の味が楽しめるようになっています。
ランチは基本的には下記のようなコースになっています。`}</p>
    <p><strong parentName="p">{`お昼のコース`}</strong></p>
    <BorderBox mdxType="BorderBox">
  <Text as="p" mdxType="Text">
    <Text as="span" fontWeight="bold" mdxType="Text">
      ・前菜セット　A　1,650円
    </Text>
    <Text as="span" fontWeight="bold" mdxType="Text">
      前菜4種盛り合わせ
    </Text>
    <Text as="span" fontWeight="bold" mdxType="Text">
      選べるおそば（せいろ・海苔せいろ・胡麻せいろ・かけそば）
    </Text>
    <Text as="span" fontWeight="bold" mdxType="Text">
      ・前菜セット　B　2,200円
    </Text>
    <Text as="span" fontWeight="bold" mdxType="Text">
      前菜4種盛り合わせ、おそばは全種類より選択可。
    </Text>
    <Text as="span" fontWeight="bold" mdxType="Text">
      ・ケヤキ　3,200円
    </Text>
    <Text as="span" fontWeight="bold" mdxType="Text">
      彩り7種盛り合わせ、旬野菜の天ぷら
    </Text>
    <Text as="span" fontWeight="bold" mdxType="Text">
      おそば 、自家製和菓子、ドリンク
    </Text>
    <Text as="span" fontWeight="bold" mdxType="Text">
      ・松原　4,000円
    </Text>
    <Text as="span" fontWeight="bold" mdxType="Text">
      彩り7種盛り合わせ、厚切り鴨ロース肉の炙り焼き
    </Text>
    <Text as="span" fontWeight="bold" mdxType="Text">
      旬野菜の天ぷら、おそば、自家製和菓子、ドリンク
    </Text>
  </Text>
    </BorderBox>
    <h3>{`ランチはこんな感じのメニュー`}</h3>
    <h4>{`前菜`}</h4>
    <p>{`旬の野菜を中心とした前菜のメニューがこちら。`}</p>
    <InstaImage postId="BwgLR1IFAli" mdxType="InstaImage" />
    <InstaImage postId="BuELdFtHLQq" mdxType="InstaImage" />
    <h4>{`お蕎麦`}</h4>
    <p>{`すだちがふんだんに使われた長年変わらない老舗名店の味が楽しめます。`}</p>
    <InstaImage postId="BtueQzPHHb3" mdxType="InstaImage" />
    <p><strong parentName="p">{`こちらは牡蠣蕎麦`}</strong></p>
    <InstaImage postId="BtIwUQ2h2wx" mdxType="InstaImage" />
    <h3>{`支払い`}</h3>
    <p>{`支払いはカードが可能となっているので、普段現金をもち歩かない人にとっては嬉しい形になっています！`}</p>
    <p>{`・カード可
（VISA、JCB、Master、Diners、AMEX）`}</p>
    <p>{`※Suica などの電子マネー不可は利用できないため、ご注意ください。`}</p>
    <h3>{`アクセス`}</h3>
    <p>{`原宿駅から徒歩 3 分という好立地にあります！
若者やファッションの中心地である原宿で、このような鎌倉を思わせる大人な雰囲気の老舗があるのは意外ですよね！`}</p>
    <GoogleMap lat={35.6695124} lng={139.7015334} mdxType="GoogleMap" />
    <hr></hr>
    <h2>{`ピッツェリアサバティーニ青山`}</h2>
    <InstaImage postId="B4J5-7chDYr" mdxType="InstaImage" />
    <InstaImage postId="B0Xvd3UAiie" exclude={[3, 4]} mdxType="InstaImage" />
    <p>{`イタリア・ローマに本店のある「リストランテ　サバティーニ青山」のカジュアル形態の姉妹店として 1983 年オープンした「ピッツェリア　サバティーニ」。原宿、青山エリアで老舗のピッツェリアとして、美味しいランチが食べられることで有名です。
食べログ評価も 3.65(2020 年 5 月時点)となっており、長らく老舗としてその実績を積んでお客様に選ばれ続けています。`}</p>
    <h3>{`現地の味に近い本格的`}</h3>
    <p>{`本格石窯で焼くクリスピーピッツァはもちろんの事、30 年余りの伝統で受け継がれてきたレシピで作られる本格イタリア料理をリーズナブルで食べられることで人気。`}</p>
    <h3>{`ローマを思わせる店内`}</h3>
    <InstaImage postId="B-jDQkVg-3H" mdxType="InstaImage" />
    <p>{`イタリア製の調度品で飾られた店内はまるでローマのような雰囲気。イタリアをより身近に感じられる、老舗の名店です。`}</p>
    <h3>{`ランチはコース`}</h3>
    <InstaImage postId="BbtTEd5A1T1" mdxType="InstaImage" />
    <p>{`前菜、お肉、ピザ、スイーツなど料理が自分で選べて食べられるボリュームのあるコース料理になっています。`}<strong parentName="p">{`普段とは少し違ったおしゃれなランチ`}</strong>{`を手軽に食べたいという方にはおすすめのランチメニューになっています。`}</p>
    <h3>{`テイクアウトもできる`}</h3>
    <p>{`老舗ピッツェリアの味をご自宅でも堪能できます！「ちょっとコースは重たい」という方にはオススメです！`}</p>
    <ListBox list={["Pizza Margherita(マルゲリータ）（1,482円）", "Pizza Quattoro Formaggio(クワットロフォルマッジョ)(2,223円)", "Panini Salmone(スモークサーモンのパニーニ)(741円)"]} mdxType="ListBox" />
    <p>{`テイクアウト可能時間：10:30〜20:30`}</p>
    <h3>{`支払い`}</h3>
    <p>{`支払いはカードが可能となっているので、普段現金をもち歩かない人にとっては嬉しい形になっています！`}</p>
    <p>{`・カード可
（VISA、JCB、Master、Diners、AMEX）`}</p>
    <p>{`※Suica などの電子マネー不可は利用できないため、ご注意ください。`}</p>
    <h3>{`アクセス`}</h3>
    <p>{`原宿駅からは少し遠く歩かないといけないので、時間に余裕がある日や天気が良い日だと散歩しながら行くことができます。
外苑前へアクセスができる方は、外苑前からお越しください。`}</p>
    <GoogleMap lat={35.6700008} lng={139.7138213} mdxType="GoogleMap" />
    <hr></hr>
    <h2>{`鳥政`}</h2>
    <InstaImage postId="B-Heo7wpNBa" mdxType="InstaImage" />
    <p>{`店頭には「南青山　鳥政」と書かれた立看板が置かれているこの鳥政は創業 40 年以上の原宿老舗の名店。
食べログの評価はなんと 3.76(2020 年 5 月時点)となっており、ランチ、ディナー問わずにお客様から選ばれ続けているお店となっています。`}</p>
    <h3>{`ランチは 3 種類から`}</h3>
    <p>{`【値段は全て 1,300 円】`}</p>
    <ListBox list={["焼き鳥丼", "焼鳥定食", "   ラーメンセット"]} mdxType="ListBox" />
    <h3>{`焼き鳥丼`}</h3>
    <InstaImage postId="BpNY-ssA-T9" mdxType="InstaImage" />
    <p>{`5 種類（レバー、もも正肉、さび焼きささみ、ネギ巻き、つくね）の鶏肉がふんだんに使用されており、焼鳥の下に盛られたご飯は殆ど見えないくらい。
40 年の老舗の焼き鳥の味が色々楽しめるメニューになっています。
レバーが苦手な人のようにレバ抜きのメニューがあるので、ご安心ください！`}</p>
    <h3>{`焼鳥定食`}</h3>
    <InstaImage postId="B2n0P3LlxIS" mdxType="InstaImage" />
    <p>{`焼き鳥丼にふんだんに使用されている鶏肉が串焼きとして提供されているランチメニューになります。
ワサビでツンとした風味も味わえるなど、鶏本来の味を味わいながら老舗のランチを食べたい方にはオススメです。`}</p>
    <h3>{`焼き鳥ラーメンセット`}</h3>
    <InstaImage postId="BhV-W5OliGk" mdxType="InstaImage" />
    <p>{`鶏がらスープを使用したラーメンと 3 種類の鶏肉がどっさりトッピングされたランチメニューになっています。
ラーメンと焼き鳥という組み合わせもバッチリ相性が合う、長年愛されているメニューになります。`}</p>
    <h3>{`支払い`}</h3>
    <p>{`支払いはカードが可能となっているので、普段現金をもち歩かない人にとっては嬉しい形になっています！`}</p>
    <p>{`・カード可
（VISA、JCB、Master、Diners、AMEX）`}</p>
    <p>{`※Suica などの電子マネー不可は利用できないため、ご注意ください。`}</p>
    <h3>{`アクセス`}</h3>
    <p>{`原宿駅から徒歩 12 分、表参道駅から徒歩 2 分という立地にあります！
原宿からは少し遠目の距離ですが、ウィンドウショッピングしながら行くとあっという間に到着すると思います。`}</p>
    <GoogleMap lat={35.6700008} lng={139.7138213} mdxType="GoogleMap" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`原宿エリアで数十年続く老舗の名店をご紹介させていただきましたが、いかがでしたでしょうか。
原宿だと老舗というイメージは持ちづらいかもしれませんが、長年続く本物の味を楽しみたい方には必見のお店になっていますので、ランチでお越しの際にはぜひチェックしてください！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;